import { render, staticRenderFns } from "./aboutCEO.vue?vue&type=template&id=641ca3aa&scoped=true&"
import script from "./aboutCEO.vue?vue&type=script&lang=js&"
export * from "./aboutCEO.vue?vue&type=script&lang=js&"
import style0 from "./aboutCEO.vue?vue&type=style&index=0&id=641ca3aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ca3aa",
  null
  
)

export default component.exports